// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Images/mountains.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Images/footer_logo_2014.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Images/JQueryUIModalBackground.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Images/loading.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Images/downarrowblue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Images/select.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Images/calendar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Images/development.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** General ****/
html {
  overflow-y: scroll
}

body {
  font-size: 12px;
  font-family: arial, helvetica, sans-serif;
  color: #333;
  background-color: #FFF;
  margin: 0;
  width: 100%;
  -webkit-text-size-adjust: none
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a, .fakeLink, .ui-widget-content a {
  text-decoration: underline;
  font-weight: normal !important;
  color: #8D6E52;
  cursor: pointer
}

a:hover, .fakeLink:hover {
  text-decoration: none
}

ul {
  margin: 0
}

h2 {
  padding: 0 0 10px 0;
  margin: 0
}

h4 {
  margin: 0.2em 0
}

.bold, legend {
  font-weight: bold
}

.linerule {
  border-top: 1px solid #aaa;
  padding-top: 8px;
  display: none
}
/**** Layout ****/
#toolBar {
  background: #f6d652;
  background: -ms-linear-gradient(top, #f8dd5c 0%,#f4c83c 60%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8dd5c', endColorstr='#f4c83c',GradientType=0 );
  padding: 2px 0;
  font-size: 12px;
  color: #715627
}

#toolBar a {
  color: #715627;
  text-decoration: none
}

#toolBar a:hover {
  color: #FFF
}

#toolBar ul {
  margin: 0;
  padding: 0
}

#toolBar li {
  list-style: none;
  display: inline;
  margin-right: 3px
}

#logo {
  background: #003269;
  background: linear-gradient(#003876 0%, #002147 60%);
  background: -ms-linear-gradient(top, #003876 0%,#002147 60%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#003876', endColorstr='#002147',GradientType=0 );
  padding: 10px 0;
  margin-bottom:25px;
}

.main {
  margin: 0 auto;
  padding: 0 10px
}

#header {
  color: #FFF
}

#headerLogo {
  float: left;
  width: 298px
}

#headerTitle {
  font-size: 25px;
  color: #FFF;
  padding: 25px 13px 0 12px;
  float: right;
  line-height: 22px
}

#headerTitle a {
  color: #FFF;
  text-decoration: none
}

#main {
  font-size: 1.2em;
  padding: 10px 15px 110px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 100%
}

.voyagerString {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 1055px;
  height: 339px;
}

footer {
  background: #00162e url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center 5%;
  padding-top: 115px;
  color: #7790ab
}

footer a {
  color: #7790ab;
  text-decoration: none
}

footer ul {
  list-style: none;
  margin: 0 0 5px;
  padding: 0
}

footer li {
  margin: 0;
  display: inline;
  list-style-type: none
}

footer li a img {
  width: 40px
}

footer .rspnd section {
  font-size: 12px;
  line-height: 18px
}

#footerInfoOne {
  float: left;
  width: 50%
}

#footerInfoTwo {
  text-align: right;
  float: right;
  width: 50%
}

.privacy {
  padding: 25px 0
}

.ui-widget-overlay {
  background: #333 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 50% 50% repeat;
  opacity: .50;
  filter: Alpha(Opacity=50);
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50)
}

.ui-dialog {
  border: 1px solid #aaaaaa;
  background: #FCFCFC;
  color: #696969
}

.ui-dialog .ui-widget-header {
  border: 1px solid #aaaaaa;
  background: #CCC;
  color: #696969;
  font-weight: bold
}
/**** Collapsible Panels ****/
.sectionContainer header.titleBar, .sectionContainer article.content {
  padding: 6px 7px;
  border-color: #AAA;
  zoom: 1;
}

.sectionContainer header.titleBar div {
  padding-right: 16px;
  font-family: Verdana,Arial,sans-serif;
  font-size: 1.1em;
}

.sectionContainer header div:after {
  content: "\\f056";
  font-family: FontAwesome;
  float:right;
}

.sectionContainer header.collapsed div:after {
  content: "\\f055";
}

.sectionContainer article.content {
  border: 1px solid #AAA;
  border-top: none;
  background: none repeat scroll 0 0 #FEFEFE;
  padding: 15px 7px;
  text-decoration: none;
  display: block
}

.msie8 .sectionContainer {
  width: 100%;
  display: inline-block;
  height: auto;
}

.bgWhite .ui-widget-content {
  background-color: #FFF
}

.messageBox, .pageMessage, .pageErrorMessage {
  box-shadow: 2px 2px 4px #aaa;
  border: 1px solid gray;
  font-size: 90%;
  text-align: center;
  padding: 6px;
  background-color: #EEEFFF;
  border-radius: 3px;
  margin: 0 0 8px
}

.ui-widget-content {
  color: #444
}

.sectionContainer .ui-accordion .ui-accordion-content {
  padding: 15px 10px;
  overflow: hidden;
  box-sizing: content-box;
  height: auto !important
}

.visible-phone, .visible-tablet {
  display: none
}

.ajaxLoading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center no-repeat;
  width: 100%;
  opacity: 0.3;
  filter: alpha(opacity=30)
}

.green {
	color:green;
}
.yellow {
	color:goldenrod;
}
.red {
	color:firebrick;
}
.blue {
	color:darkblue;
}
.lightgray {
  color:lightgray;
}
.modal-body hr {
  margin:10px 0;
}

/* Nav */
nav {
  padding: 5px 15px 0;
  margin-bottom: 15px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid #AAA;
  font-size: 1.35em;
  line-height: 22px;
  z-index: 1040;
  background-color: #FFF;
}

nav #siteName {
  float: left;
  text-transform: none
}

nav ul {
  list-style: none;
  padding: 0;
  float: right;
  margin: 0;
  position: relative;
  background-color: #FFF
}

nav li {
  float: left;
  position: relative;
  cursor: pointer
}

nav li a {
  color: #002147;
  font: 400 13px/1.4;
  padding: 0 10px 3px;
  text-decoration: none;
  display: block;
  border-bottom: none
}

nav li a.sf-with-ul {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center right;
  padding-right: 12px
}

nav li a:hover, nav li.sfHover a, nav li.current a {
  border-bottom: 3px solid gold;
  padding-bottom: 0
}

nav li ul li {
  background-color: #002147
}

nav li ul li:first-child {
  padding-top: 11px
}

nav li ul li:last-child {
  padding-bottom: 11px
}

nav li ul li a, nav li.sfHover ul li a {
  border: none;
  padding: 5px 0 5px 16px;
  color: #FFF;
  font-size: 14px;
  line-height: 16px
}

nav li ul li a:hover, nav li.sfHover ul li a:hover {
  color: #FFC82E
}

#menu-icon {
  color: #002147;
  cursor: pointer;
  display: none;
  font-size: 1.3em;
  border: 1px solid #002147;
  padding: 10px;
  border-bottom: none;
}

#menu-icon i {
  float: left;
}

#menu-icon div {
  float: right;
}

nav ul ul {
  position: absolute;
  top: 26px;
  height: 0;
  left: 0;
}

nav ul ul li {
  float: none
}

nav ul ul li a {
  border-radius: 0;
  text-align: left;
  width: 200px
}

nav ul li:hover ul {
  visibility: visible
}

.nav-fixed {
  height: 71px;
}
/* General */
a img {
  border: none
}

a.delete, .fakeLink.delete {
  color: #000080
}

.center {
  margin: 0 auto
}

.clear {
  clear: both
}

.information, .success, .error, .formValidationText, .field-validation-error, .validation-summary-errors {
  border-radius: 2px;
  padding: 3px 4px;
  display: block;
  border-width: 1px;
  border-style: solid
}

.information {
  background-color: #e4f2ff;
  border-color: #b9dbe5
}

.success {
  background-color: #ebfae3 !important;
  border-color: #b9d3b1 !important
}

.error, .formValidationText, .field-validation-error, .validation-summary-errors {
  background-color: #fefccb;
  border-color: #e5db55;
  margin: 2px 0 8px
}

input.error, .input-validation-error {
  background-color: #ffd2d3 !important;
  border: 1px solid #df8f90 !important
}

.field-validation-valid, .validation-summary-valid {
  display: none
}

header {
  font-weight: bold;
  margin: 0 0 1px;
  display: block
}

form {
  margin: 0;
}

.ui-autocomplete {
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.skipnav a, .skipnav a:active, .skipnav a:link, .accessibleText {
  height: 1px;
  left: -10000px;
  overflow: hidden;
  position: absolute;
  width: 1px
}

.skipnav a:focus, .skipnav a:active {
  color: #fff;
  position: static;
  left: 0;
  width: auto;
  height: auto;
  overflow: visible;
  text-decoration: underline
}

.skipnav a:hover {
  color: #fff;
  cursor: pointer;
  text-decoration: underline
}

#toolBar ul#fontResizer {
  padding-top: 2px;
  float: left
}

#fontResizer a.currFont {
  text-decoration: underline
}

#toolBarLinks {
  float: right;
  line-height: 27px
}

#toolBarLinks li {
  border-left: 1px solid #715627;
  padding-left: 9px
}

#toolBarLinks li:first-child {
  border-left: none;
  padding-left: 0
}

.smallFont {
  font-size: 0.75em
}

.mediumFont {
  font-size: .95em
}

.largeFont {
  font-size: 1.3em
}

.rj {
  text-align: right
}

.b {
  font-weight: bold
}
/* input */
input[type="text"], input[type="password"], input[type="file"], textarea, select {
  background: #FFF;
  border-color: #C0C0C0 #D9D9D9 #D9D9D9;
  border-width: 1px;
  border-style: solid;
  margin: 0;
  display: inline-block;
  padding: 5px 8px;
  font: 100%/1.5 helvetica,arial,sans-serif;
  color: #444;
  outline: none;
  border-radius: 2px;
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.msie7 input[type="text"], .msie8 input[type="text"], .msie7 input[type="password"], .msie8 input[type="password"] {
  padding: 2px 0 8px 8px
}

.msie9 input[type="text"], .msie9 input[type="password"], .msie9 input[type="file"], .msie9 textarea, .msie9 select,
.msie1 input[type="text"], .msie1 input[type="password"], .msie1 input[type="file"], .msie1 textarea, .msie9 select {
  line-height: 1;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  font-stretch: normal;
  font-family: Tahoma,Arial;
  font-size: 100%;
  padding: 5px 8px 3px
}

select {
  padding: 4px 8px
}

.webkit select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: top right;
  background-repeat: no-repeat
}

input[type="text"]:active, input[type="text"]:focus, input[type="text"]:hover, input[type="password"]:active, input[type="password"]:focus, input[type="password"]:hover, input[type="file"]:active, input[type="file"]:focus, input[type="file"]:hover, textarea:active, textarea:focus, textarea:hover, select:active, select:focus, select:hover {
  background-color: #FFFEF2
}


a.btn-default{
	line-height:32px;
  text-decoration:none;
}


input[type="radio"], input[type="checkbox"] {
  display: inline-block;
  margin-top: 3px
}

textarea {
  min-height: 76px
}

input[disabled="disabled"], input[disabled], textarea[disabled="disabled"], textarea[disabled], select[disabled="disabled"], select[disabled], .disabledInput {
  background-color: #FCFCFC;
  color: #888;
  border-color: #BDBDBD #D7D7D7 #D7D7D7
}

input[type="text"].calendar, input[type="date"].calendar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: center right;
  padding-right: 22px
}

.ui-widget-content h3, .ui-widget-content h4 {
  padding: 6px;
  background-color: #F5F5F5;
  margin-bottom: 10px
}

.rspnd INPUT {
  font-family: inherit;
  font-size: 14px
}

.nicEdit-main {
  background-color: #FFF;
  margin: 0 !important;
  padding: 4px;
  min-height: 80px !important
}

.nicEdit-panelContain, .nicEdit-main {
  display: none
}

#main .nicEdit-panelContain, #main .nicEdit-main {
  display: block
}
/* Login */
.loginbox {
  width: 350px;
  margin: 0 auto
}

.loginbox h2 {
  border-bottom: 1px solid #AAA;
  padding-bottom: 5px;
  margin-bottom: 10px
}

.loginbox h3 {
  font-size: 1.5em
}

.loginbox label {
  display: block;
  font-size: 18px
}

.loginbox input[type="text"], .loginbox input[type="password"], .loginbox input[type="submit"],
.loginbox button, .loginbox .btn {
  display: block;
  margin-bottom: 8px;
  font-size: 140%;
  width: 350px
}

.loginbox input[type="submit"], .loginbox button, .loginbox .btn {
  padding: 5px 0;
  margin-top: 15px;
  height: 39px
}
/**** Table ****/
table {
  border-spacing: 0
}

table td, table th {
  margin: 0
}
/**** Under Development ****/
#INJECTED_DEV_NOTICE {
  width: 100%;
  text-shadow: 2px 2px 8px #000;
  font-family: Helvetica;
  font-size: 14pt;
  background-color: #660000;
  margin: 0;
  color: #fff;
  border-bottom: solid 1px black;
  padding: 0
}

#INJECTED_DEV_NOTICE a {
  color: #FFF;
  text-decoration: underline;
  font-size: 12px
}

.UNDERDEV {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) repeat 50% 100%
}
/****** Responsive ******/
/**** Full Size ****/
@media (min-width:1200px) {
  .main {
    max-width: 1170px
  }
}

@media only screen and (max-width:1024px) and (orientation:landscape),only screen and (max-width:1024px) and (orientation:portrait) {
  .hidden-phone {
    display: inherit
  }

  .hidden-tablet {
    display: none
  }

  .visible-tablet {
    display: block
  }
}

@media only screen and (min-width:980px) {
  #nav {
    display: block !important
  }
}
/**** iPad Portrait ****/
@media (max-width:979px) {
  #menu-icon {
    display: block !important;
    border-bottom: 1px solid #002147;
    min-height: 40px;
  }

  #nav {
    z-index: 10000;
    display: none;
    border: 1px solid #002147;
    border-top: none;
    text-align: left
  }

  nav {
    border: none
  }

  nav #siteName {
    float: none;
    padding-bottom: 15px;
    color: #002147;
    font-size: 20px
  }

  nav ul {
    float: none
  }

  nav li {
    float: none
  }

  nav li a {
    display: block;
    border: none;
    text-transform: none;
    font-size: 1.3em;
    border-radius: 0;
    margin: 0;
    font: 400 13px/1.4;
    padding: 6px 10px
  }

  nav .sf-sub-indicator {
    display: none
  }

  nav ul ul {
    visibility: visible !important;
    display: block !important;
    position: relative;
    height: auto;
    top: auto
  }

  nav ul ul li a {
    padding-left: 35px;
    width: auto
  }

  nav li.sfHover ul li a {
    border: none;
    border-top: 1px solid #fff
  }

  nav ul ul li:first-child {
    border: none
  }

  nav li li:first-child a {
    margin-left: 0
  }

  nav li a.sf-with-ul {
    background: none;
    padding: 6px 10px
  }

  nav li a:hover, nav li.sfHover a, nav li.current a {
    border: none;
    padding: 6px 10px
  }

  nav li ul {
    padding: 0
  }

  nav li ul li {
    background: none
  }

  nav li ul li a, nav li.sfHover ul li a {
    color: #002147;
    font-size: 1.3em;
    line-height: 22px
  }

  nav li ul li:first-child {
    padding-top: 0
  }

  nav li ul li:last-child {
    padding-bottom: 0
  }

  nav li ul li a:hover, nav li.sfHover ul li a:hover {
    color: #002147
  }

  .linerule {
    display: block
  }

  .linerule:nth-last-child(1) {
    display: none
  }

  .main {
    max-width: 959px
  }

  #INJECTED_DEV_NOTICE {
    font-size: 12px
  }
}
/**** iPad portrait ****/
@media (min-width:768px) and (max-width:979px) {
  [class*="span"] {
    float: left;
    margin-left: 20px
  }

  #headerTitle {
    top: 25px
  }

  .main {
    max-width: 959px
  }
}
/* iPhone landscape */
@media (max-width:767px) {
  .main {
    max-width: 767px
  }

  #loginForm {
    width: 100%
  }

  #headerTitle {
    float: none;
    text-align: center;
    padding: 15px 0
  }

  #headerLogo {
    margin: 0 auto;
    float: none
  }
}
/* iPhone portrait */
@media (max-width:480px) {
  .hidden-phone {
    display: none
  }

  .visible-phone {
    display: block
  }

  #headerLogo a {
    left: 0;
    top: 9px
  }

  .main {
    max-width: 480px
  }


  #headerBg img {
    display: none
  }

  footer ul {
    float: left
  }

  #footerInfoOne {
    border-bottom: 1px solid #7790ab;
    float: none;
    width: 100%;
    padding-bottom: 10px
  }

  #footerInfoTwo {
    text-align: left;
    float: none;
    padding-top: 20px;
    width: 100%
  }

  .loginbox {
    width: auto;
    border: none;
    box-shadow: none;
    padding: 0
  }

  .loginInput {
    margin: 0 auto;
    width: 90%
  }

  .loginInput input[type="text"], .loginInput input[type="password"], .loginInput input[type="submit"] {
    width: 100%
  }
}

/* styles for validation helpers */
.field-validation-error {
  color: #b94a48;
}

.field-validation-valid {
  display: none;
}

input.input-validation-error {
  border: 1px solid #b94a48;
}


select.input-validation-error {
  border: 1px solid #b94a48;
}

input[type="checkbox"].input-validation-error {
  border: 0 none;
}

.validation-summary-errors {
  color: #b94a48;
}

.validation-summary-valid {
  display: none;
}


.ui-widget-content h4.ui-accordion-header {
  padding: 0;
  margin-bottom: 0;
  margin-top: 3px
}

#main ul, #main li {
  margin: 0;
  padding: 0;
  line-height: 24px
}

li {
  list-style-type: none
}

.result {
  color: #3A7D34;
  padding-top: 12px;
  font-weight: bold
}

.result.red {
  color: #EC3F41
}

.highlightHover:hover, .activeRow {
  background-color: #D2D1D9
}

.manage {
  text-decoration: underline;
  cursor: pointer
}

#searchResults {
  min-height: 100px
}

.ajaxLoading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center no-repeat;
  height: 291px;
  width: 100%;
  opacity: 0.8;
  filter: alpha(opacity=80)
}

#userDetails {
  background-color: #FFF;
  border: 1px solid #ccc;
  cursor: default
}

.breakline {
  cursor: pointer
}

.ui-datepicker .ui-datepicker-prev, .ui-datepicker .ui-datepicker-next {
  top: 6px
}

.clickToShow section {
  color: #E1E2E5;
  cursor: pointer;
  background-color: #E1E2E5
}

.no-underline a {
  text-decoration: none;
}
.inlinebootstrapbutton, input[type="submit"].inlinebootstrapbutton {
  margin-top:25px;
}

.tab-content {
	padding:8px;
	border-color:transparent #ddd #ddd #ddd;
	border-image:none;
	border-style:solid;
	border-width:1px;
}

.filez {
	background-color:#F7F7F7;
	margin:0 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
.fileicon {
	font-size:30px;
	color:#041E42;
}
.fileicon a {
	color:#041E42;
}
.filename {
	text-decoration:none;
	font-weight:bold !important;
	color: #4d4d4c;
}
.filedetails {
	font-size:12px;
	color:#777;
}

.flex-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: flex-start;
}

.footer {
  margin-top: auto;
  padding-top:0px;
}

.results {
  width: 50%;
  margin: auto;
}

.footerP {
  padding-top: 20px;
}

.headerImage{
  content:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) ;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE;AACF;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX;AACF;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB;AACF;AACA,iBAAiB;AACjB;EACE,mBAAmB;EAKnB,4DAA4D;EAC5D,mHAAmH;EACnH,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EAKpD,4DAA4D;EAC5D,mHAAmH;EACnH,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,+EAA4E;EAC5E,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uEAA2E;EAC3E,YAAY;EACZ,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd;AACF;AACA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;EACjB,qBAAqB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EAGE,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EAGzB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAGhB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2EAA+D;EAC/D,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;CACC,WAAW;AACZ;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA,QAAQ;AACR;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd;AACF;;AAEA;EACE,0EAAoE;EACpE;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,OAAO;AACT;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;AACA,YAAY;AACZ;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA,UAAU;AACV;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;EACzC,WAAW;EACX,aAAa;EAGb,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yDAA4C;EAC5C,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;;AAGA;CACC,gBAAgB;EACf,oBAAoB;AACtB;;;AAGA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX;AACF;;AAEA;EACE,yDAA8C;EAC9C,4BAA4B;EAC5B,iCAAiC;EACjC;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA,UAAU;AACV;EACE,YAAY;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;AACA,gBAAgB;AAChB;EACE;AACF;;AAEA;EACE;AACF;AACA,4BAA4B;AAC5B;EACE,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;AACA,yBAAyB;AACzB,oBAAoB;AACpB;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;AACA,wBAAwB;AACxB;EACE;IACE,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB;EACF;;EAEA;IACE;EACF;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB;EACF;;EAEA;IACE;EACF;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB;EACF;;EAEA;IACE,YAAY;IACZ;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB;EACF;;EAEA;IACE,YAAY;IACZ;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;AACA,wBAAwB;AACxB;EACE;IACE,WAAW;IACX;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;AACA,qBAAqB;AACrB;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB;EACF;;EAEA;IACE,cAAc;IACd;EACF;AACF;AACA,oBAAoB;AACpB;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,OAAO;IACP;EACF;;EAEA;IACE;EACF;;;EAGA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX;EACF;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IAEZ,gBAAgB;IAChB;EACF;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE;EACF;AACF;;AAEA,kCAAkC;AAClC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,UAAU;EACV,gBAAgB;EAChB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2EAA+D;EAC/D,aAAa;EACb,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,cAAc;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;CACC,cAAc;CACd,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,oBAAoB;CACpB,2BAA2B;CAC3B,cAAc;AACf;AACA;CACC,cAAc;CACd,UAAU;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAA6C;AAC/C","sourcesContent":["/**** General ****/\nhtml {\n  overflow-y: scroll\n}\n\nbody {\n  font-size: 12px;\n  font-family: arial, helvetica, sans-serif;\n  color: #333;\n  background-color: #FFF;\n  margin: 0;\n  width: 100%;\n  -webkit-text-size-adjust: none\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na, .fakeLink, .ui-widget-content a {\n  text-decoration: underline;\n  font-weight: normal !important;\n  color: #8D6E52;\n  cursor: pointer\n}\n\na:hover, .fakeLink:hover {\n  text-decoration: none\n}\n\nul {\n  margin: 0\n}\n\nh2 {\n  padding: 0 0 10px 0;\n  margin: 0\n}\n\nh4 {\n  margin: 0.2em 0\n}\n\n.bold, legend {\n  font-weight: bold\n}\n\n.linerule {\n  border-top: 1px solid #aaa;\n  padding-top: 8px;\n  display: none\n}\n/**** Layout ****/\n#toolBar {\n  background: #f6d652;\n  background: -moz-linear-gradient(top, #f8dd5c 0%, #f4c83c 60%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f8dd5c), color-stop(60%,#f4c83c));\n  background: -webkit-linear-gradient(top, #f8dd5c 0%,#f4c83c 60%);\n  background: -o-linear-gradient(top, #f8dd5c 0%,#f4c83c 60%);\n  background: -ms-linear-gradient(top, #f8dd5c 0%,#f4c83c 60%);\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8dd5c', endColorstr='#f4c83c',GradientType=0 );\n  padding: 2px 0;\n  font-size: 12px;\n  color: #715627\n}\n\n#toolBar a {\n  color: #715627;\n  text-decoration: none\n}\n\n#toolBar a:hover {\n  color: #FFF\n}\n\n#toolBar ul {\n  margin: 0;\n  padding: 0\n}\n\n#toolBar li {\n  list-style: none;\n  display: inline;\n  margin-right: 3px\n}\n\n#logo {\n  background: #003269;\n  background: linear-gradient(#003876 0%, #002147 60%);\n  background: -moz-linear-gradient(top, #003876 0%, #002147 60%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#003876), color-stop(60%,#002147));\n  background: -webkit-linear-gradient(top, #003876 0%,#002147 6%);\n  background: -o-linear-gradient(top, #003876 0%,#002147 60%);\n  background: -ms-linear-gradient(top, #003876 0%,#002147 60%);\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#003876', endColorstr='#002147',GradientType=0 );\n  padding: 10px 0;\n  margin-bottom:25px;\n}\n\n.main {\n  margin: 0 auto;\n  padding: 0 10px\n}\n\n#header {\n  color: #FFF\n}\n\n#headerLogo {\n  float: left;\n  width: 298px\n}\n\n#headerTitle {\n  font-size: 25px;\n  color: #FFF;\n  padding: 25px 13px 0 12px;\n  float: right;\n  line-height: 22px\n}\n\n#headerTitle a {\n  color: #FFF;\n  text-decoration: none\n}\n\n#main {\n  font-size: 1.2em;\n  padding: 10px 15px 110px;\n  background: url(\"./Images/mountains.png\") no-repeat 50% 100%\n}\n\n.voyagerString {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 1055px;\n  height: 339px;\n}\n\nfooter {\n  background: #00162e url(\"./Images/footer_logo_2014.png\") no-repeat center 5%;\n  padding-top: 115px;\n  color: #7790ab\n}\n\nfooter a {\n  color: #7790ab;\n  text-decoration: none\n}\n\nfooter ul {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0\n}\n\nfooter li {\n  margin: 0;\n  display: inline;\n  list-style-type: none\n}\n\nfooter li a img {\n  width: 40px\n}\n\nfooter .rspnd section {\n  font-size: 12px;\n  line-height: 18px\n}\n\n#footerInfoOne {\n  float: left;\n  width: 50%\n}\n\n#footerInfoTwo {\n  text-align: right;\n  float: right;\n  width: 50%\n}\n\n.privacy {\n  padding: 25px 0\n}\n\n.ui-widget-overlay {\n  background: #333 url(\"./Images/JQueryUIModalBackground.png\") 50% 50% repeat;\n  opacity: .50;\n  filter: Alpha(Opacity=50);\n  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50)\n}\n\n.ui-dialog {\n  border: 1px solid #aaaaaa;\n  background: #FCFCFC;\n  color: #696969\n}\n\n.ui-dialog .ui-widget-header {\n  border: 1px solid #aaaaaa;\n  background: #CCC;\n  color: #696969;\n  font-weight: bold\n}\n/**** Collapsible Panels ****/\n.sectionContainer header.titleBar, .sectionContainer article.content {\n  padding: 6px 7px;\n  border-color: #AAA;\n  zoom: 1;\n}\n\n.sectionContainer header.titleBar div {\n  padding-right: 16px;\n  font-family: Verdana,Arial,sans-serif;\n  font-size: 1.1em;\n}\n\n.sectionContainer header div:after {\n  content: \"\\f056\";\n  font-family: FontAwesome;\n  float:right;\n}\n\n.sectionContainer header.collapsed div:after {\n  content: \"\\f055\";\n}\n\n.sectionContainer article.content {\n  border: 1px solid #AAA;\n  border-top: none;\n  background: none repeat scroll 0 0 #FEFEFE;\n  padding: 15px 7px;\n  text-decoration: none;\n  display: block\n}\n\n.msie8 .sectionContainer {\n  width: 100%;\n  display: inline-block;\n  height: auto;\n}\n\n.bgWhite .ui-widget-content {\n  background-color: #FFF\n}\n\n.messageBox, .pageMessage, .pageErrorMessage {\n  -webkit-box-shadow: 2px 2px 4px #aaa;\n  -moz-box-shadow: 2px 2px 4px #aaa;\n  box-shadow: 2px 2px 4px #aaa;\n  border: 1px solid gray;\n  font-size: 90%;\n  text-align: center;\n  padding: 6px;\n  background-color: #EEEFFF;\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n  margin: 0 0 8px\n}\n\n.ui-widget-content {\n  color: #444\n}\n\n.sectionContainer .ui-accordion .ui-accordion-content {\n  padding: 15px 10px;\n  overflow: hidden;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  height: auto !important\n}\n\n.visible-phone, .visible-tablet {\n  display: none\n}\n\n.ajaxLoading {\n  background: url(\"./Images/loading.gif\") center center no-repeat;\n  width: 100%;\n  opacity: 0.3;\n  filter: alpha(opacity=30)\n}\n\n.green {\n\tcolor:green;\n}\n.yellow {\n\tcolor:goldenrod;\n}\n.red {\n\tcolor:firebrick;\n}\n.blue {\n\tcolor:darkblue;\n}\n.lightgray {\n  color:lightgray;\n}\n.modal-body hr {\n  margin:10px 0;\n}\n\n/* Nav */\nnav {\n  padding: 5px 15px 0;\n  margin-bottom: 15px;\n  text-align: center;\n  position: relative;\n  border-bottom: 1px solid #AAA;\n  font-size: 1.35em;\n  line-height: 22px;\n  z-index: 1040;\n  background-color: #FFF;\n}\n\nnav #siteName {\n  float: left;\n  text-transform: none\n}\n\nnav ul {\n  list-style: none;\n  padding: 0;\n  float: right;\n  margin: 0;\n  position: relative;\n  background-color: #FFF\n}\n\nnav li {\n  float: left;\n  position: relative;\n  cursor: pointer\n}\n\nnav li a {\n  color: #002147;\n  font: 400 13px/1.4;\n  padding: 0 10px 3px;\n  text-decoration: none;\n  display: block;\n  border-bottom: none\n}\n\nnav li a.sf-with-ul {\n  background: url(\"./Images/downarrowblue.png\") no-repeat center right;\n  padding-right: 12px\n}\n\nnav li a:hover, nav li.sfHover a, nav li.current a {\n  border-bottom: 3px solid gold;\n  padding-bottom: 0\n}\n\nnav li ul li {\n  background-color: #002147\n}\n\nnav li ul li:first-child {\n  padding-top: 11px\n}\n\nnav li ul li:last-child {\n  padding-bottom: 11px\n}\n\nnav li ul li a, nav li.sfHover ul li a {\n  border: none;\n  padding: 5px 0 5px 16px;\n  color: #FFF;\n  font-size: 14px;\n  line-height: 16px\n}\n\nnav li ul li a:hover, nav li.sfHover ul li a:hover {\n  color: #FFC82E\n}\n\n#menu-icon {\n  color: #002147;\n  cursor: pointer;\n  display: none;\n  font-size: 1.3em;\n  border: 1px solid #002147;\n  padding: 10px;\n  border-bottom: none;\n}\n\n#menu-icon i {\n  float: left;\n}\n\n#menu-icon div {\n  float: right;\n}\n\nnav ul ul {\n  position: absolute;\n  top: 26px;\n  height: 0;\n  left: 0;\n}\n\nnav ul ul li {\n  float: none\n}\n\nnav ul ul li a {\n  border-radius: 0;\n  text-align: left;\n  width: 200px\n}\n\nnav ul li:hover ul {\n  visibility: visible\n}\n\n.nav-fixed {\n  height: 71px;\n}\n/* General */\na img {\n  border: none\n}\n\na.delete, .fakeLink.delete {\n  color: #000080\n}\n\n.center {\n  margin: 0 auto\n}\n\n.clear {\n  clear: both\n}\n\n.information, .success, .error, .formValidationText, .field-validation-error, .validation-summary-errors {\n  border-radius: 2px;\n  padding: 3px 4px;\n  display: block;\n  border-width: 1px;\n  border-style: solid\n}\n\n.information {\n  background-color: #e4f2ff;\n  border-color: #b9dbe5\n}\n\n.success {\n  background-color: #ebfae3 !important;\n  border-color: #b9d3b1 !important\n}\n\n.error, .formValidationText, .field-validation-error, .validation-summary-errors {\n  background-color: #fefccb;\n  border-color: #e5db55;\n  margin: 2px 0 8px\n}\n\ninput.error, .input-validation-error {\n  background-color: #ffd2d3 !important;\n  border: 1px solid #df8f90 !important\n}\n\n.field-validation-valid, .validation-summary-valid {\n  display: none\n}\n\nheader {\n  font-weight: bold;\n  margin: 0 0 1px;\n  display: block\n}\n\nform {\n  margin: 0;\n}\n\n.ui-autocomplete {\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.skipnav a, .skipnav a:active, .skipnav a:link, .accessibleText {\n  height: 1px;\n  left: -10000px;\n  overflow: hidden;\n  position: absolute;\n  width: 1px\n}\n\n.skipnav a:focus, .skipnav a:active {\n  color: #fff;\n  position: static;\n  left: 0;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  text-decoration: underline\n}\n\n.skipnav a:hover {\n  color: #fff;\n  cursor: pointer;\n  text-decoration: underline\n}\n\n#toolBar ul#fontResizer {\n  padding-top: 2px;\n  float: left\n}\n\n#fontResizer a.currFont {\n  text-decoration: underline\n}\n\n#toolBarLinks {\n  float: right;\n  line-height: 27px\n}\n\n#toolBarLinks li {\n  border-left: 1px solid #715627;\n  padding-left: 9px\n}\n\n#toolBarLinks li:first-child {\n  border-left: none;\n  padding-left: 0\n}\n\n.smallFont {\n  font-size: 0.75em\n}\n\n.mediumFont {\n  font-size: .95em\n}\n\n.largeFont {\n  font-size: 1.3em\n}\n\n.rj {\n  text-align: right\n}\n\n.b {\n  font-weight: bold\n}\n/* input */\ninput[type=\"text\"], input[type=\"password\"], input[type=\"file\"], textarea, select {\n  background: #FFF;\n  border-color: #C0C0C0 #D9D9D9 #D9D9D9;\n  border-width: 1px;\n  border-style: solid;\n  margin: 0;\n  display: inline-block;\n  padding: 5px 8px;\n  font: 100%/1.5 helvetica,arial,sans-serif;\n  color: #444;\n  outline: none;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  width: 25%;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\n\n.msie7 input[type=\"text\"], .msie8 input[type=\"text\"], .msie7 input[type=\"password\"], .msie8 input[type=\"password\"] {\n  padding: 2px 0 8px 8px\n}\n\n.msie9 input[type=\"text\"], .msie9 input[type=\"password\"], .msie9 input[type=\"file\"], .msie9 textarea, .msie9 select,\n.msie1 input[type=\"text\"], .msie1 input[type=\"password\"], .msie1 input[type=\"file\"], .msie1 textarea, .msie9 select {\n  line-height: 1;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  font-stretch: normal;\n  font-family: Tahoma,Arial;\n  font-size: 100%;\n  padding: 5px 8px 3px\n}\n\nselect {\n  padding: 4px 8px\n}\n\n.webkit select {\n  background-image: url(\"./Images/select.png\");\n  background-position: top right;\n  background-repeat: no-repeat\n}\n\ninput[type=\"text\"]:active, input[type=\"text\"]:focus, input[type=\"text\"]:hover, input[type=\"password\"]:active, input[type=\"password\"]:focus, input[type=\"password\"]:hover, input[type=\"file\"]:active, input[type=\"file\"]:focus, input[type=\"file\"]:hover, textarea:active, textarea:focus, textarea:hover, select:active, select:focus, select:hover {\n  background-color: #FFFEF2\n}\n\n\na.btn-default{\n\tline-height:32px;\n  text-decoration:none;\n}\n\n\ninput[type=\"radio\"], input[type=\"checkbox\"] {\n  display: inline-block;\n  margin-top: 3px\n}\n\ntextarea {\n  min-height: 76px\n}\n\ninput[disabled=\"disabled\"], input[disabled], textarea[disabled=\"disabled\"], textarea[disabled], select[disabled=\"disabled\"], select[disabled], .disabledInput {\n  background-color: #FCFCFC;\n  color: #888;\n  border-color: #BDBDBD #D7D7D7 #D7D7D7\n}\n\ninput[type=\"text\"].calendar, input[type=\"date\"].calendar {\n  background-image: url(\"./Images/calendar.png\");\n  background-repeat: no-repeat;\n  background-position: center right;\n  padding-right: 22px\n}\n\n.ui-widget-content h3, .ui-widget-content h4 {\n  padding: 6px;\n  background-color: #F5F5F5;\n  margin-bottom: 10px\n}\n\n.rspnd INPUT {\n  font-family: inherit;\n  font-size: 14px\n}\n\n.nicEdit-main {\n  background-color: #FFF;\n  margin: 0 !important;\n  padding: 4px;\n  min-height: 80px !important\n}\n\n.nicEdit-panelContain, .nicEdit-main {\n  display: none\n}\n\n#main .nicEdit-panelContain, #main .nicEdit-main {\n  display: block\n}\n/* Login */\n.loginbox {\n  width: 350px;\n  margin: 0 auto\n}\n\n.loginbox h2 {\n  border-bottom: 1px solid #AAA;\n  padding-bottom: 5px;\n  margin-bottom: 10px\n}\n\n.loginbox h3 {\n  font-size: 1.5em\n}\n\n.loginbox label {\n  display: block;\n  font-size: 18px\n}\n\n.loginbox input[type=\"text\"], .loginbox input[type=\"password\"], .loginbox input[type=\"submit\"],\n.loginbox button, .loginbox .btn {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 140%;\n  width: 350px\n}\n\n.loginbox input[type=\"submit\"], .loginbox button, .loginbox .btn {\n  padding: 5px 0;\n  margin-top: 15px;\n  height: 39px\n}\n/**** Table ****/\ntable {\n  border-spacing: 0\n}\n\ntable td, table th {\n  margin: 0\n}\n/**** Under Development ****/\n#INJECTED_DEV_NOTICE {\n  width: 100%;\n  text-shadow: 2px 2px 8px #000;\n  font-family: Helvetica;\n  font-size: 14pt;\n  background-color: #660000;\n  margin: 0;\n  color: #fff;\n  border-bottom: solid 1px black;\n  padding: 0\n}\n\n#INJECTED_DEV_NOTICE a {\n  color: #FFF;\n  text-decoration: underline;\n  font-size: 12px\n}\n\n.UNDERDEV {\n  background: url(\"./Images/development.png\") repeat 50% 100%\n}\n/****** Responsive ******/\n/**** Full Size ****/\n@media (min-width:1200px) {\n  .main {\n    max-width: 1170px\n  }\n}\n\n@media only screen and (max-width:1024px) and (orientation:landscape),only screen and (max-width:1024px) and (orientation:portrait) {\n  .hidden-phone {\n    display: inherit\n  }\n\n  .hidden-tablet {\n    display: none\n  }\n\n  .visible-tablet {\n    display: block\n  }\n}\n\n@media only screen and (min-width:980px) {\n  #nav {\n    display: block !important\n  }\n}\n/**** iPad Portrait ****/\n@media (max-width:979px) {\n  #menu-icon {\n    display: block !important;\n    border-bottom: 1px solid #002147;\n    min-height: 40px;\n  }\n\n  #nav {\n    z-index: 10000;\n    display: none;\n    border: 1px solid #002147;\n    border-top: none;\n    text-align: left\n  }\n\n  nav {\n    border: none\n  }\n\n  nav #siteName {\n    float: none;\n    padding-bottom: 15px;\n    color: #002147;\n    font-size: 20px\n  }\n\n  nav ul {\n    float: none\n  }\n\n  nav li {\n    float: none\n  }\n\n  nav li a {\n    display: block;\n    border: none;\n    text-transform: none;\n    font-size: 1.3em;\n    border-radius: 0;\n    margin: 0;\n    font: 400 13px/1.4;\n    padding: 6px 10px\n  }\n\n  nav .sf-sub-indicator {\n    display: none\n  }\n\n  nav ul ul {\n    visibility: visible !important;\n    display: block !important;\n    position: relative;\n    height: auto;\n    top: auto\n  }\n\n  nav ul ul li a {\n    padding-left: 35px;\n    width: auto\n  }\n\n  nav li.sfHover ul li a {\n    border: none;\n    border-top: 1px solid #fff\n  }\n\n  nav ul ul li:first-child {\n    border: none\n  }\n\n  nav li li:first-child a {\n    margin-left: 0\n  }\n\n  nav li a.sf-with-ul {\n    background: none;\n    padding: 6px 10px\n  }\n\n  nav li a:hover, nav li.sfHover a, nav li.current a {\n    border: none;\n    padding: 6px 10px\n  }\n\n  nav li ul {\n    padding: 0\n  }\n\n  nav li ul li {\n    background: none\n  }\n\n  nav li ul li a, nav li.sfHover ul li a {\n    color: #002147;\n    font-size: 1.3em;\n    line-height: 22px\n  }\n\n  nav li ul li:first-child {\n    padding-top: 0\n  }\n\n  nav li ul li:last-child {\n    padding-bottom: 0\n  }\n\n  nav li ul li a:hover, nav li.sfHover ul li a:hover {\n    color: #002147\n  }\n\n  .linerule {\n    display: block\n  }\n\n  .linerule:nth-last-child(1) {\n    display: none\n  }\n\n  .main {\n    max-width: 959px\n  }\n\n  #INJECTED_DEV_NOTICE {\n    font-size: 12px\n  }\n}\n/**** iPad portrait ****/\n@media (min-width:768px) and (max-width:979px) {\n  [class*=\"span\"] {\n    float: left;\n    margin-left: 20px\n  }\n\n  #headerTitle {\n    top: 25px\n  }\n\n  .main {\n    max-width: 959px\n  }\n}\n/* iPhone landscape */\n@media (max-width:767px) {\n  .main {\n    max-width: 767px\n  }\n\n  #loginForm {\n    width: 100%\n  }\n\n  #headerTitle {\n    float: none;\n    text-align: center;\n    padding: 15px 0\n  }\n\n  #headerLogo {\n    margin: 0 auto;\n    float: none\n  }\n}\n/* iPhone portrait */\n@media (max-width:480px) {\n  .hidden-phone {\n    display: none\n  }\n\n  .visible-phone {\n    display: block\n  }\n\n  #headerLogo a {\n    left: 0;\n    top: 9px\n  }\n\n  .main {\n    max-width: 480px\n  }\n\n\n  #headerBg img {\n    display: none\n  }\n\n  footer ul {\n    float: left\n  }\n\n  #footerInfoOne {\n    border-bottom: 1px solid #7790ab;\n    float: none;\n    width: 100%;\n    padding-bottom: 10px\n  }\n\n  #footerInfoTwo {\n    text-align: left;\n    float: none;\n    padding-top: 20px;\n    width: 100%\n  }\n\n  .loginbox {\n    width: auto;\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    padding: 0\n  }\n\n  .loginInput {\n    margin: 0 auto;\n    width: 90%\n  }\n\n  .loginInput input[type=\"text\"], .loginInput input[type=\"password\"], .loginInput input[type=\"submit\"] {\n    width: 100%\n  }\n}\n\n/* styles for validation helpers */\n.field-validation-error {\n  color: #b94a48;\n}\n\n.field-validation-valid {\n  display: none;\n}\n\ninput.input-validation-error {\n  border: 1px solid #b94a48;\n}\n\n\nselect.input-validation-error {\n  border: 1px solid #b94a48;\n}\n\ninput[type=\"checkbox\"].input-validation-error {\n  border: 0 none;\n}\n\n.validation-summary-errors {\n  color: #b94a48;\n}\n\n.validation-summary-valid {\n  display: none;\n}\n\n\n.ui-widget-content h4.ui-accordion-header {\n  padding: 0;\n  margin-bottom: 0;\n  margin-top: 3px\n}\n\n#main ul, #main li {\n  margin: 0;\n  padding: 0;\n  line-height: 24px\n}\n\nli {\n  list-style-type: none\n}\n\n.result {\n  color: #3A7D34;\n  padding-top: 12px;\n  font-weight: bold\n}\n\n.result.red {\n  color: #EC3F41\n}\n\n.highlightHover:hover, .activeRow {\n  background-color: #D2D1D9\n}\n\n.manage {\n  text-decoration: underline;\n  cursor: pointer\n}\n\n#searchResults {\n  min-height: 100px\n}\n\n.ajaxLoading {\n  background: url(\"./Images/loading.gif\") center center no-repeat;\n  height: 291px;\n  width: 100%;\n  opacity: 0.8;\n  filter: alpha(opacity=80)\n}\n\n#userDetails {\n  background-color: #FFF;\n  border: 1px solid #ccc;\n  cursor: default\n}\n\n.breakline {\n  cursor: pointer\n}\n\n.ui-datepicker .ui-datepicker-prev, .ui-datepicker .ui-datepicker-next {\n  top: 6px\n}\n\n.clickToShow section {\n  color: #E1E2E5;\n  cursor: pointer;\n  background-color: #E1E2E5\n}\n\n.no-underline a {\n  text-decoration: none;\n}\n.inlinebootstrapbutton, input[type=\"submit\"].inlinebootstrapbutton {\n  margin-top:25px;\n}\n\n.tab-content {\n\tpadding:8px;\n\tborder-color:transparent #ddd #ddd #ddd;\n\tborder-image:none;\n\tborder-style:solid;\n\tborder-width:1px;\n}\n\n.filez {\n\tbackground-color:#F7F7F7;\n\tmargin:0 0 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n.fileicon {\n\tfont-size:30px;\n\tcolor:#041E42;\n}\n.fileicon a {\n\tcolor:#041E42;\n}\n.filename {\n\ttext-decoration:none;\n\tfont-weight:bold !important;\n\tcolor: #4d4d4c;\n}\n.filedetails {\n\tfont-size:12px;\n\tcolor:#777;\n}\n\n.flex-wrapper {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.footer {\n  margin-top: auto;\n  padding-top:0px;\n}\n\n.results {\n  width: 50%;\n  margin: auto;\n}\n\n.footerP {\n  padding-top: 20px;\n}\n\n.headerImage{\n  content:url(\"./Images/footer_logo_2014.png\") ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
